import React, { Component } from "react";
import { GET, POST, loading, alert } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo-landscape.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      token: "",
      email: "",
      password: "",
      confirm_password: "",
    };
  }

  // เปิดลิงก์ = เช็คว่าลิงก์ยังใช้ได้ แล้วให้ลูกค้าตั้งรหัสผ่านเองก่อน verify (2026-11-04)
  // แอดมินไม่ต้องส่งรหัสผ่านให้ลูกค้า — POST v1/public/verify-email ตั้งรหัส + verify ในครั้งเดียว
  async componentDidMount() {
    loading(false);
    const token = window.location.pathname.replace("/verify/", "");
    const result = await GET("v1/public/verify-email", { token: token });
    if (result?.status) {
      this.setState({ status: "set_password", token, email: result?.data?.email || "" });
    } else {
      this.setState({ status: "error" });
    }
  }

  Submit = async () => {
    const { token, password, confirm_password } = this.state;
    if (!password) {
      alert("", "warning", "Warning", "Please input Password");
      return;
    } else if (password.trim().length < 6) {
      alert("", "warning", "Warning", "Please enter a password that is at least 6 characters long.");
      return;
    } else if (!confirm_password) {
      alert("", "warning", "Warning", "Please input Confirm Password");
      return;
    } else if (password !== confirm_password) {
      alert("", "warning", "Warning", "Password not match");
      return;
    }
    loading(true);
    const result = await POST("v1/public/verify-email", { token, password: btoa(unescape(encodeURIComponent(password))) });
    loading(false);
    if (result?.status) {
      this.setState({ status: "success", password: "", confirm_password: "" });
    }
  };

  render() {
    const { status, email, password, confirm_password } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pp-scope">
        <div className="row mx-0">
          <div className="col-11 col-sm-8 col-md-6 col-xl-5 col-xxl-4 py-4 mx-auto">
            <div className="ar-hero mb-4">
              <img
                alt="logo"
                src={LOGO}
                height={34}
                style={{ objectFit: "contain" }}
                className="mb-3"
              />
              <div className="ar-eyebrow mb-1">Account</div>
            </div>
            {status === "set_password" && (
              <div className="rounded-4 bg-white shadow-sm p-4">
                <h3 className="fw-bold mb-2 text-center">Set your password</h3>
                <p className="text-secondary text-center mb-3">
                  Create a password to verify your account
                  {email ? (
                    <>
                      {" "}
                      <b>{email}</b>
                    </>
                  ) : null}
                  .
                </p>
                <hr />
                <label className="mb-1">Password</label>
                <input
                  type="password"
                  className="form-control mb-3"
                  placeholder="At least 6 characters"
                  autoComplete="new-password"
                  onChange={(e) => this.setState({ password: e.target.value })}
                  value={password}
                />
                <label className="mb-1">Confirm Password</label>
                <input
                  type="password"
                  className="form-control mb-3"
                  placeholder="Confirm Password..."
                  autoComplete="new-password"
                  onChange={(e) => this.setState({ confirm_password: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") this.Submit();
                  }}
                  value={confirm_password}
                />
                <button
                  type="button"
                  className="btn ar-btn-gold w-100 justify-content-center mt-2"
                  onClick={() => this.Submit()}
                >
                  Verify &amp; Set Password
                </button>
              </div>
            )}
            {status === "success" && (
              <div className="rounded-4 bg-white shadow-sm p-4 text-center">
                <span className="icon text-success text-72 mb-3">
                  {"\uf058"}
                </span>
                <h3 className="fw-bold mb-3">Email Verification</h3>
                <hr />
                <span>
                  Your account is verified and your password has been set.
                  You can now log in.
                </span>
                <br />
                <button
                  className="btn ar-btn-gold justify-content-center mt-3 mb-3"
                  onClick={() => (window.location.href = "/")}
                >
                  Go to Login
                </button>
              </div>
            )}
            {status === "error" && (
              <div className="rounded-4 bg-white shadow-sm p-4 text-center">
                <span className="icon text-warning text-72 mb-3">
                  {"\uf06a"}
                </span>
                <h3 className="fw-bold mb-3">
                  Email Verification link expired
                </h3>
                <hr />
                <span>
                  Looks like the verification link has expired. Not to worry,we
                  can send the link again.
                </span>
                <br />
                <button
                  className="btn ar-btn-gold justify-content-center mt-3 mb-2"
                  onClick={() => (window.location.href = "/resend-verification")}
                >
                  Resend verification link
                </button>
                <br />
                <button
                  className="btn btn-link text-dark mb-3"
                  onClick={() => (window.location.href = "/")}
                >
                  Return to Home Page
                </button>
              </div>
            )}
            {status === "not_found" && (
              <div className="center w-100 min-vh-100 d-flex justify-content-center align-items-center">
                <div className="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-8 col-xxl-6 mx-auto">
                  <div className="p-5 text-center">
                    <h1 className="fw-bold mb-4 text-72">404</h1>
                    <h3 className="mb-4">
                      ขออภัย ไม่พบหน้าเว็บไซต์ที่คุณต้องการ
                    </h3>
                    <button
                      type="button"
                      className="btn ar-btn-gold justify-content-center wpx-200 mt-3 mx-auto"
                      onClick={() => {
                        window.location.href = "/";
                      }}
                    >
                      กลับไปสู่หน้าหลัก
                    </button>
                    <div class="w-100 text-center mt-4">
                      <small class="text-secondary">
                        เวอร์ชั่น {global.version}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
